import type { CloudflareImage } from '~~/layers/base/types/printingProcess'

/**
 * A map of aspect ratios to their corresponding width and height values.
 * The values can be used directly in the `style` attribute of a element
 * to set the `aspect-ratio` CSS property.
 */
export const ASPECT_RATIOS: Record<CloudflareImage['aspectRatio'], string> = {
    media: '1200/779',
    landscape: '1200/779',
    portrait: '1200/1355',
    landscapeTall: '480/367',
}
